import { useFormatDate } from "@/hooks/useFormatDate"
import { isNotNullNorUndefined } from "@/utils/ts-utils"

type Props = {
  date?: string | null
  includeTime?: boolean
  options?: Intl.DateTimeFormatOptions
  dft?: string
}

export default function FormattedDate({ date, includeTime, options, dft }: Props) {
  const formatDate = useFormatDate({ includeTime, options })

  return isNotNullNorUndefined(date) ? <>{formatDate(date)}</> : <>{dft ?? ""}</>
}
